import React from 'react';
import {TableDropdownProps} from './TableDropdown.props';
import './TableDropdown.styles.css';
import {Text} from '../../atoms/Text';
import {Image} from '../../atoms/Image';
import {Images} from '../../../configs/images';
import {alpha, styled} from "@mui/material/styles";
import Menu, {MenuProps} from "@mui/material/Menu";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

let nextTableDropdownId = 0;

export const TableDropdown: React.FC<TableDropdownProps> = ({
  title,
  data,
  color = '#fff',
  backgroundHover,
  background,
  borderRadius,
  variant,
  onClick,
  emailId,
  dropdownValue,
  padding,
  actionHideDropdown,
  onValueChange,
  ariaLabel,
  fontSize = 12,
  width,
  justifyContent,
}) => {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorHover, setAnchorHover] = React.useState<any>(null);
  const [dropdownId] = React.useState(() => `table-dropdown-${++nextTableDropdownId}`);
  const triggerId = `${dropdownId}-trigger`;
  const menuId = `${dropdownId}-menu`;
  const open = Boolean(anchorEl);

  const showActionsDropdown = (trigger: HTMLElement) => {
    setAnchorEl(trigger);
    dropdownValue?.(trigger.getAttribute('data-id'));
  };
  const handleTriggerClick = (event: React.MouseEvent<HTMLElement>) => {
    showActionsDropdown(event.currentTarget);
  };
  const handleTriggerKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    showActionsDropdown(event.currentTarget);
  };
  const hideActionsDropdown = () => {
    setAnchorEl(null);
    if(anchorHover && !anchorHover.target.classList.contains('status'))
      anchorHover.target.style.background = background
  };
  const handleMouseOver = (e:any) => {
    if(!e.target.classList.contains('status')){
      e.target.style.background = backgroundHover
    }
    setAnchorHover(e);
  }
  const handleMouseLeave = (e:any) => {
    if(!e.target.classList.contains('status'))
      e.target.style.background = background
      if(open)
        e.target.style.background = backgroundHover
  }
  return (
      <div className="table-dropdown" >
        <div
          className={"action-dropdown-list " + variant + ' ' + title}
          style={{
            color,
            background,
            borderRadius,
            padding,
            ...(width !== undefined ? {width} : {}),
            ...(justifyContent !== undefined ? {justifyContent} : {}),
          }}
          onClick={data ? handleTriggerClick : () => {}}
          onKeyDown={data ? handleTriggerKeyDown : undefined}
          data-id={emailId}
          onMouseEnter={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          role={data ? 'button' : undefined}
          tabIndex={data ? 0 : undefined}
          aria-label={ariaLabel || title}
          id={data ? triggerId : undefined}
          aria-haspopup={data ? 'menu' : undefined}
          aria-expanded={data ? open : undefined}
          aria-controls={data && open ? menuId : undefined}
        >
          <Text children={title} color={color} fontSize={fontSize} fontWeight={700} margin='0 6px 0 0'/>
          {data ? <svg className='arrow-down' width="8" height="4" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.984375 0.984375H11.0156L6 6L0.984375 0.984375Z" fill={color}/>
          </svg> : null}
        </div>
        <StyledMenu
          MenuListProps={{
            id: menuId,
            'aria-labelledby': triggerId,
          }}
          anchorEl={anchorEl}
          open={data ? open : false}
          onClose={hideActionsDropdown}
        >
          <div className='actions-rules'>
            <ul>
              {
                data ? Object.keys(data).map((item:string) => <li className={item === title ? 'active': ''} key={item} onClick={(e:any) => {
                  onValueChange?.(item);
                  if(onClick) {
                    onClick(e);
                  }
                  hideActionsDropdown();
                }} value={item}>{item} {item === title ? <Image margin={"0 0 0 auto"} srcImg={Images.IconChecked} width={11} height={18}/> : ""}</li>) : null
              }
            </ul>
          </div>
        </StyledMenu>
      </div>
  );
};
